import axios from '@/api/client';

const state = {
  bilder: null,
  bild: null
};

const getters = {
  stateBilder: state => state.bilder,
  stateBild: state => state.bild,
};

const actions = {
  async createBild({dispatch}, bild) {
    await axios.post('bild', bild);
    await dispatch('getBilder');
  },

  async createBildRotate({dispatch}, payload) {
    console.log('## in store >>createBildRotate',payload,dispatch)
    const asString2 = new URLSearchParams(payload).toString();
    const url = 'bildRotate?'+asString2
    let {data} = await axios.post(url);
    console.log('<-<-<-<-<>>>bild:',data)
    await dispatch('getBilder');  //hier nicht alle neue laden sondern nur das Eine!!!
  },
async createBildmitfiles(_, payload) {
  const { data } = await axios.post('bildermitfiles', payload);
  return data; // neues Bild / Response zurückgeben
},
  //liefert nur zu angemeldetem User
  async getBilder({ commit }, payload = {}) {
      // payload kann z.B. { offset: 0, anzahl_Bilder: 20 } sein
      const { data } = await axios.post('bilder', null, {
        params: payload
      });
      commit('setBilder', data);
      return data;
    },
  //liefert zu allen Usern
  async postBilder({commit}) {
    console.log('<-<-<-<-<>postBild:')
    let {data} = await axios.post('bilder');
    commit('setBilder', data);
    },
  async viewBild({commit}, id) {
    console.log('viewBild:',id)

    let {data} = await axios.get(`bilder/${id}`);
    commit('setBild', data);
  },
  // eslint-disable-next-line no-empty-pattern
  async updateBild({}, payload) {
    //await axios.patch(`bild/${bild.id}`, bild.form);
    const asString2 = new URLSearchParams(payload).toString();
    const url = 'bild?'+asString2
    let {data} = await axios.post(url);

    console.log('<-<-<-<-<>>>bild:',data)
  },
  // eslint-disable-next-line no-empty-pattern
  async deleteBild({}, id) {
    await axios.delete(`bild/${id}`);
  }
};

const mutations = {
  setBilder(state, bilder){
    state.bilder= bilder;
  },
  setBild(state, bild){
    state.bild = bild;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};